<template>
  <div>
    <div class="el-section">
      <emd-container :title="seeMore ? $t('summary') : $t('summaryDetails')" summary>
        <template v-slot:summary>
          <Items v-if="showItems && !isMobile" />
          <Link v-if="showLink && !isMobile" />
          <Payment v-if="showPayment && !isMobile" />
          <hr class="emd-divider" v-if="!isMobile" />
          <div class="emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap">
            <span class="emd-label eu-display_inline-block summary-title">{{ $t('subtotal') }}</span>
            <span class="emd-text _type_caption eu-display_inline-block eu-ml_1 value-label">
              {{ subtotal }}
            </span>
          </div>
          <hr class="emd-divider" v-if="hasShipping" />
          <div class="emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap" v-if="hasShipping">
            <span class="emd-label eu-display_inline-block summary-title">{{ $t('shipping') }}</span>
            <span class="emd-text _type_caption eu-display_inline-block eu-ml_1 shipping-label">
              {{ shippingCurrencyFormat }}
           </span>
          </div>
          <hr class="emd-divider" v-if="hasShipping" />
          <div class="emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap" v-if="hasShipping">
            <span class="emd-label eu-display_inline-block summary-title">{{ $t('total') }}</span>
            <span class="emd-text _type_caption eu-display_inline-block eu-ml_1 value-label">
              {{ total }}
            </span>
          </div>
        </template>
        <template v-slot:footer v-if="!isMobile">
          <hr class="emd-divider" />
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md eu-align_center eu-no-margin_md eu-pa_3 eu-px_3">
            <a @click="expandSummary" class="summary-footer">
              <i v-if="seeMore" class="uil uil-angle-down"></i>
              <i v-else class="uil uil-angle-up"></i>
              <span>{{ seeMore ? $t('seeMoreDetails') : $t('seeLessDetails') }}</span>
            </a>
          </div>
        </template>
      </emd-container>
    </div>
  </div>
</template>

<script>
import EmdContainer from '@/components/emerald/molecules/EmdContainer'
import { formatCurrency, formatToInt } from '@/utils/validations'
import Items from './Items.vue'
import Link from './Link.vue'
import Payment from './Payment.vue'

export default {
  name: 'Summary',
  components: {
    EmdContainer,
    Items,
    Link,
    Payment
  },
  data () {
    return {
      seeMore: false,
      showItems: false,
      showLink: false,
      showPayment: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      }
    }
  },
  props: {
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    items () {
      return this.$store.getters.paymentLinkItems
    },
    shipping () {
      return this.$store.getters.paymentLinkShipping
    },
    hasShipping () {
      return this.shipping !== 'R$ 0,00'
    },
    paymentLinkStatus () {
      return this.$store.getters.paymentLinkStatus
    },
    paymentLinkData () {
      return this.$store.getters.paymentLinkData
    },
    subtotal () {
      const items = this.items
      let sum = 0

      items.forEach(item => {
        sum = sum + this.subtotalItem(item)
      })

      return formatCurrency(sum)
    },
    total () {
      const shipping = formatToInt(this.shipping)
      const subtotal = formatToInt(this.subtotal)

      return formatCurrency((shipping + subtotal) / 100)
    },
    shippingCurrencyFormat () {
      return formatCurrency(this.shipping / 100)
    }
  },
  created () {
    if (this.expanded) {
      this.seeMore = true
    }
    this.expandSummary()
  },
  methods: {
    expandSummary () {
      if (this.seeMore) {
        this.showItems = true
        this.showLink = true
        this.showPayment = true
        this.seeMore = false
      } else {
        if (this.paymentLinkStatus === 'products-services') {
          this.showItems = true
          this.showLink = false
          this.showPayment = false
        } else if (this.paymentLinkStatus === 'link-settings') {
          this.showItems = false
          this.showLink = true
          this.showPayment = false
        } else if (this.paymentLinkStatus === 'payment-methods') {
          this.showItems = false
          this.showLink = false
          this.showPayment = true
        }
        this.seeMore = true
      }
    },
    subtotalItem (item) {
      if (item.default_quantity && item.amount) {
        const quantity = item.default_quantity
        const amount = formatToInt(item.amount)
        const subtotal = (amount * quantity) / 100

        return subtotal
      }

      return 0
    }
  }
}
</script>

<style>
._mode_dark .summary-content, ._mode_dark .summary-label, ._mode_dark .value-label {
  color: #c4c6c8 !important;
}

.summary-title {
  color: #8B8B92;
  font-weight: 700;
  font-size: 12px;
  word-break: break-all;
}

.summary-content {
  color: #070817;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}

.summary-label {
  color: #070817;
  font-size: 14px;
  font-weight: 700;
  word-break: break-all;
}

.summary-footer {
  width: 100%;
  cursor: pointer;
  font-weight:700;
  font-size: 12px;
  color: #72737A
}

.shipping-label {
  color: #72737A;
  font-weight: 700;
  font-size: 14px;
  word-break: break-all;
}

.info-label {
  font-weight: 400;
  font-size: 12px;
  color: #72737A;
}

.value-label {
  font-weight: 700;
  font-size: 16px;
  color: #070817;
}
</style>

<i18n>
{
  "pt-BR": {
    "summary": "Resumo",
    "summaryDetails": "Detalhes do resumo",
    "subtotal": "Subtotal",
    "shipping": "Frete",
    "total": "Total",
    "seeLessDetails": "Ver menos detalhes",
    "seeMoreDetails": "Ver mais detalhes"
  },
  "en-US": {
    "summary": "Summary",
    "summaryDetails": "Summary details",
    "subtotal": "Subtotal",
    "shipping": "Shipping",
    "total": "Total",
    "seeLessDetails": "See less details",
    "seeMoreDetails": "See more details"
  }
}
</i18n>
